import upperCase from 'lodash/upperCase';
export var GTMEvent = function GTMEvent(newLaneEventData) {
  if (typeof window !== 'undefined') {
    var snakeCasePlacementName = upperCase(newLaneEventData.placement_nm).split(' ').join('_');
    var event = "MTT_" + snakeCasePlacementName + "_ONSITE_MESSAGING." + newLaneEventData.selected_treatment_nm;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event
    });
  }
};